import { render, staticRenderFns } from "./importErrorList.vue?vue&type=template&id=678b2390&scoped=true&"
import script from "./importErrorList.vue?vue&type=script&lang=js&"
export * from "./importErrorList.vue?vue&type=script&lang=js&"
import style0 from "./importErrorList.vue?vue&type=style&index=0&id=678b2390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b2390",
  null
  
)

export default component.exports